var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficialConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49967 15.6667H4.83301C3.72844 15.6667 2.83301 14.7712 2.83301 13.6667V5.75C2.83301 4.64543 3.72844 3.75 4.83301 3.75H19.1663C20.2709 3.75 21.1663 4.64543 21.1663 5.75V13.6667C21.1663 14.7712 20.2709 15.6667 19.1663 15.6667H17.4997H6.49967Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.33301 7.41699L8.33301 12.0003",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 16.583V19.333",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 7.41699V12.0003",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.667 7.41699L15.667 12.0003",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.58301 20.25H18.4163",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialConsole);
export default __webpack_public_path__ + "static/media/official-console.458183f047c3431fcef39ec4296765d0.svg";
export { ForwardRef as ReactComponent };